import { supabase } from '../lib/supabase.js';

export class ManualOrderManager {
  constructor() {
    this.selectedCustomer = null;
    this.orderItems = [];
    this.clothingItems = [];
    this.totals = {
      subtotal: 0,
      deliveryFee: 15.00, // Default delivery fee
     tipAmount: 0,
      discount: 0,
      total: 0
    };
    this.isLoading = false;
    this.isCreatingOrder = false;
  }

  render() {
    return `
      <div class="bg-white rounded-lg shadow p-6">
        <div class="flex justify-between items-center mb-6">
          <div>
            <h2 class="text-xl font-bold text-gray-900">Create Manual Order</h2>
            <p class="text-gray-600">Create orders manually for phone or walk-in customers</p>
          </div>
          <button 
            id="reset-order-form-btn" 
            class="bg-gray-600 text-white px-4 py-2 rounded-md hover:bg-gray-700"
          >
            Reset Form
          </button>
        </div>

        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <!-- Customer Information -->
          <div class="space-y-6">
            <!-- Customer Search -->
            <div class="bg-blue-50 p-4 rounded-lg border border-blue-200">
              <h3 class="font-medium text-blue-900 mb-3">🔍 Find Existing Customer</h3>
              <div class="space-y-3">
                <input 
                  type="text" 
                  id="customer-search" 
                  placeholder="Search by email or phone number..."
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-violet-500"
                >
                <button 
                  id="search-customer-btn" 
                  class="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 disabled:opacity-50 w-full"
                >
                  Search Customer
                </button>
                <div id="customer-search-results" class="hidden space-y-2 max-h-40 overflow-y-auto">
                  <!-- Search results will appear here -->
                </div>
              </div>
            </div>

            <!-- Customer Details Form -->
            <div class="bg-gray-50 p-4 rounded-lg">
              <h3 class="font-medium text-gray-900 mb-4">👤 Customer Information</h3>
              <div class="space-y-4">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Full Name *</label>
                    <input 
                      type="text" 
                      id="customer-name" 
                      required
                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-violet-500"
                      placeholder="Enter full name"
                    >
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Email *</label>
                    <input 
                      type="email" 
                      id="customer-email" 
                      required
                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-violet-500"
                      placeholder="Enter email address"
                    >
                  </div>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Phone *</label>
                    <input 
                      type="tel" 
                      id="customer-phone" 
                      required
                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-violet-500"
                      placeholder="e.g., 6041234567"
                    >
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Service Area *</label>
                    <select 
                      id="customer-service-area" 
                      required
                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-violet-500"
                    >
                      <option value="">Select service area</option>
                      <option value="south-surrey">South Surrey</option>
                      <option value="white-rock">White Rock</option>
                      <option value="langley">Langley</option>
                    </select>
                  </div>
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Address *</label>
                  <input 
                    type="text" 
                    id="customer-address" 
                    required
                    class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-violet-500"
                    placeholder="Street address"
                  >
                </div>

                <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">City *</label>
                    <input 
                      type="text" 
                      id="customer-city" 
                      required
                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-violet-500"
                      placeholder="City"
                    >
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Province</label>
                    <select 
                      id="customer-province" 
                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-violet-500"
                    >
                      <option value="BC">BC</option>
                      <option value="AB">AB</option>
                      <option value="ON">ON</option>
                    </select>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Postal Code</label>
                    <input 
                      type="text" 
                      id="customer-postal-code" 
                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-violet-500"
                      placeholder="V4B 3X4"
                    >
                  </div>
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Unit Number</label>
                  <input 
                    type="text" 
                    id="customer-unit" 
                    class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-violet-500"
                    placeholder="Unit/Suite number (optional)"
                  >
                </div>
              </div>
            </div>

            <!-- Order Scheduling -->
            <div class="bg-violet-50 p-4 rounded-lg border border-violet-200">
              <h3 class="font-medium text-violet-900 mb-4">📅 Scheduling</h3>
              <div class="space-y-4">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Pickup Date *</label>
                    <input 
                      type="date" 
                      id="pickup-date" 
                      required
                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-violet-500"
                    >
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Pickup Time *</label>
                    <select 
                      id="pickup-time-slot" 
                      required
                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-violet-500"
                    >
                      <option value="">Select time slot</option>
                      <option value="afternoon">Afternoon (4:00 PM - 6:00 PM)</option>
                      <option value="evening">Evening (6:00 PM - 8:00 PM)</option>
                    </select>
                  </div>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Delivery Date *</label>
                    <input 
                      type="date" 
                      id="delivery-date" 
                      required
                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-violet-500"
                    >
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Delivery Time *</label>
                    <select 
                      id="delivery-time-slot" 
                      required
                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-violet-500"
                    >
                      <option value="">Select time slot</option>
                      <option value="afternoon">Afternoon (4:00 PM - 6:00 PM)</option>
                      <option value="evening">Evening (6:00 PM - 8:00 PM)</option>
                    </select>
                  </div>
                </div>

                <div class="flex items-center">
                  <input 
                    type="checkbox" 
                    id="is-express-service" 
                    class="h-4 w-4 text-violet-600 focus:ring-violet-500 border-gray-300 rounded"
                  >
                  <label for="is-express-service" class="ml-2 text-sm text-gray-700">
                    Express Service (Same-day delivery, +$5.00)
                  </label>
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Special Instructions</label>
                  <textarea 
                    id="special-instructions" 
                    rows="3"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-violet-500"
                    placeholder="Any special handling instructions..."
                  ></textarea>
                </div>
              </div>
            </div>
          </div>

          <!-- Manual Discount and Tip Section -->
          <div class="bg-red-50 p-4 rounded-lg border border-red-200">
            <h3 class="font-medium text-red-900 mb-4">💸 Manual Discount & Tip</h3>
            
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <!-- Manual Discount -->
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">Discount Amount</label>
                <input 
                  type="number" 
                  id="manual-discount-amount" 
                  step="0.01"
                  min="0"
                  value="0"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-violet-500"
                  placeholder="0.00"
                >
                <div class="grid grid-cols-3 gap-1 mt-2">
                  <button type="button" class="discount-preset-btn bg-gray-200 text-gray-700 px-2 py-1 rounded text-xs hover:bg-gray-300" data-discount="0">
                    $0
                  </button>
                  <button type="button" class="discount-preset-btn bg-gray-200 text-gray-700 px-2 py-1 rounded text-xs hover:bg-gray-300" data-discount="5">
                    $5
                  </button>
                  <button type="button" class="discount-preset-btn bg-gray-200 text-gray-700 px-2 py-1 rounded text-xs hover:bg-gray-300" data-discount="10">
                    $10
                  </button>
                </div>
              </div>
              
              <!-- Tip Amount -->
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">Tip Amount</label>
                <input 
                  type="number" 
                  id="tip-amount" 
                  step="0.01"
                  min="0"
                  value="0"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-violet-500"
                  placeholder="0.00"
                >
                <div class="grid grid-cols-3 gap-1 mt-2">
                  <button type="button" class="tip-preset-btn bg-gray-200 text-gray-700 px-2 py-1 rounded text-xs hover:bg-gray-300" data-tip="0">
                    $0
                  </button>
                  <button type="button" class="tip-preset-btn bg-gray-200 text-gray-700 px-2 py-1 rounded text-xs hover:bg-gray-300" data-tip="5">
                    $5
                  </button>
                  <button type="button" class="tip-preset-btn bg-gray-200 text-gray-700 px-2 py-1 rounded text-xs hover:bg-gray-300" data-tip="10">
                    $10
                  </button>
                </div>
              </div>
            </div>
            
            <!-- Order Summary Display -->
            <div class="mt-4 pt-4 border-t border-red-200">
              <div class="space-y-2 text-sm">
                <div class="flex justify-between">
                  <span>Subtotal:</span>
                  <span id="subtotal-display">$0.00</span>
                </div>
                <div class="flex justify-between">
                  <span>Delivery Fee:</span>
                  <span id="delivery-fee-display">$15.00</span>
                </div>
                <div class="flex justify-between">
                  <span>Tip:</span>
                  <span id="tip-display">$0.00</span>
                </div>
                <div class="flex justify-between">
                  <span>Discount:</span>
                  <span id="discount-display">-$0.00</span>
                </div>
                <div class="border-t pt-2 mt-2">
                  <div class="flex justify-between font-bold text-lg">
                    <span>Total:</span>
                    <span id="total-display" class="text-red-600">$15.00</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Order Items and Summary -->
          <div class="space-y-6">
            <!-- Add Items -->
            <div class="bg-green-50 p-4 rounded-lg border border-green-200">
              <h3 class="font-medium text-green-900 mb-4">👕 Add Clothing Items</h3>
              <div class="space-y-3">
                <div class="grid grid-cols-2 gap-3">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Item</label>
                    <select 
                      id="item-select" 
                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-violet-500"
                    >
                      <option value="">Select item...</option>
                    </select>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Quantity</label>
                    <input 
                      type="number" 
                      id="item-quantity" 
                      min="1"
                      value="1"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-violet-500"
                    >
                  </div>
                </div>
                <button 
                  id="add-item-btn" 
                  class="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 disabled:opacity-50 w-full"
                  disabled
                >
                  Add Item to Order
                </button>
              </div>
            </div>

            <!-- Selected Items -->
            <div class="bg-gray-50 p-4 rounded-lg">
              <h3 class="font-medium text-gray-900 mb-4">📋 Order Items</h3>
              <div id="selected-items-list" class="space-y-2">
                <div class="text-gray-500 text-center py-4">
                  No items added yet. Add items above to begin.
                </div>
              </div>
            </div>

            <!-- Payment Method Selection -->
            <div class="bg-yellow-50 p-4 rounded-lg border border-yellow-200">
              <h3 class="font-medium text-yellow-900 mb-4">💳 Payment Method</h3>
              <div class="space-y-3">
                <label class="flex items-center">
                  <input 
                    type="radio" 
                    name="payment-method" 
                    value="manual_cash" 
                    checked
                    class="h-4 w-4 text-yellow-600 focus:ring-yellow-500 border-gray-300"
                  >
                  <span class="ml-2 text-sm text-gray-700">Cash Payment (In Person)</span>
                </label>
                <label class="flex items-center">
                  <input 
                    type="radio" 
                    name="payment-method" 
                    value="manual_card" 
                    class="h-4 w-4 text-yellow-600 focus:ring-yellow-500 border-gray-300"
                  >
                  <span class="ml-2 text-sm text-gray-700">Card Payment (In Person)</span>
                </label>
                <label class="flex items-center">
                  <input 
                    type="radio" 
                    name="payment-method" 
                    value="manual_etransfer" 
                    class="h-4 w-4 text-yellow-600 focus:ring-yellow-500 border-gray-300"
                  >
                  <span class="ml-2 text-sm text-gray-700">E-Transfer</span>
                </label>
              </div>
            </div>

            <!-- Create Order Button -->
            <button 
              id="create-order-btn" 
              class="w-full bg-violet-600 text-white px-6 py-3 rounded-md hover:bg-violet-700 disabled:opacity-50 disabled:cursor-not-allowed font-medium"
              disabled
            >
              <span id="create-order-text">Create Order</span>
              <span id="create-order-loading" class="hidden">Creating Order...</span>
            </button>
          </div>
        </div>

        <!-- Notification Area -->
        <div id="manual-order-notification" class="hidden mt-6 p-4 rounded-md">
          <div id="manual-order-notification-content"></div>
        </div>
      </div>
    `;
  }

  async bindEvents() {
    await this.loadClothingItems();

    // Customer search
    document.getElementById('search-customer-btn').addEventListener('click', () => {
      this.searchCustomer();
    });

    document.getElementById('customer-search').addEventListener('keypress', (e) => {
      if (e.key === 'Enter') {
        this.searchCustomer();
      }
    });

    // Item selection
    document.getElementById('item-select').addEventListener('change', () => {
      this.updateAddItemButton();
    });

    document.getElementById('item-quantity').addEventListener('input', () => {
      this.updateAddItemButton();
    });

    document.getElementById('add-item-btn').addEventListener('click', () => {
      this.addItemToOrder();
    });

    // Form changes to update totals and validation
    document.getElementById('is-express-service').addEventListener('change', () => {
      this.calculateTotals();
    });

   // Tip amount change event
   document.getElementById('tip-amount').addEventListener('input', () => {
     this.calculateTotals();
   });

   // Tip preset buttons
   document.querySelectorAll('.tip-preset-btn').forEach(btn => {
     btn.addEventListener('click', (e) => {
       const tipAmount = parseFloat(e.target.dataset.tip);
       document.getElementById('tip-amount').value = tipAmount.toFixed(2);
       this.calculateTotals();
     });
   });

    // Manual discount amount change event
    document.getElementById('manual-discount-amount').addEventListener('input', () => {
      this.calculateTotals();
    });

    // Discount preset buttons
    document.querySelectorAll('.discount-preset-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const discountAmount = parseFloat(e.target.dataset.discount);
        document.getElementById('manual-discount-amount').value = discountAmount.toFixed(2);
        this.calculateTotals();
      });
    });

    // Form validation for create order button
    ['customer-name', 'customer-email', 'customer-phone', 'customer-service-area', 
     'customer-address', 'customer-city', 'pickup-date', 'pickup-time-slot', 
     'delivery-date', 'delivery-time-slot'].forEach(fieldId => {
      document.getElementById(fieldId).addEventListener('input', () => {
        this.validateForm();
      });
      document.getElementById(fieldId).addEventListener('change', () => {
        this.validateForm();
      });
    });

    // Create order button
    document.getElementById('create-order-btn').addEventListener('click', () => {
      this.createOrder();
    });

    // Reset form button
    document.getElementById('reset-order-form-btn').addEventListener('click', () => {
      this.resetForm();
    });

    // Set default dates (tomorrow for pickup, day after tomorrow for delivery)
    this.setDefaultDates();
  }

  setDefaultDates() {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    
    const dayAfterTomorrow = new Date();
    dayAfterTomorrow.setDate(dayAfterTomorrow.getDate() + 2);

    document.getElementById('pickup-date').value = tomorrow.toISOString().split('T')[0];
    document.getElementById('delivery-date').value = dayAfterTomorrow.toISOString().split('T')[0];
  }

  async loadClothingItems() {
    try {
      const { data: items, error } = await supabase
        .from('clothing_items')
        .select('*')
        .eq('is_active', true)
        .order('category')
        .order('name');

      if (error) throw error;

      this.clothingItems = items || [];
      this.populateItemsDropdown();
    } catch (error) {
      this.showError('Error loading clothing items: ' + error.message);
    }
  }

  populateItemsDropdown() {
    const select = document.getElementById('item-select');
    select.innerHTML = '<option value="">Select item...</option>';

    // Group items by category for better organization
    const itemsByCategory = this.clothingItems.reduce((acc, item) => {
      const category = this.formatCategoryName(item.category);
      if (!acc[category]) acc[category] = [];
      acc[category].push(item);
      return acc;
    }, {});

    Object.entries(itemsByCategory).forEach(([category, items]) => {
      const optgroup = document.createElement('optgroup');
      optgroup.label = category;
      
      items.forEach(item => {
        const option = document.createElement('option');
        option.value = item.id;
        option.textContent = `${item.name} - $${item.base_price}`;
        option.dataset.price = item.base_price;
        option.dataset.name = item.name;
        optgroup.appendChild(option);
      });
      
      select.appendChild(optgroup);
    });
  }

  formatCategoryName(category) {
    return category.split('_').map(word => 
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ');
  }

  async searchCustomer() {
    const searchTerm = document.getElementById('customer-search').value.trim();
    if (!searchTerm) return;

    const searchBtn = document.getElementById('search-customer-btn');
    const resultsDiv = document.getElementById('customer-search-results');
    
    searchBtn.disabled = true;
    searchBtn.textContent = 'Searching...';

    try {
      const { data: customers, error } = await supabase
        .from('customers')
        .select('*')
        .or(`email.ilike.%${searchTerm}%,phone.ilike.%${searchTerm}%`)
        .order('created_at', { ascending: false })
        .limit(5);

      if (error) throw error;

      if (customers.length === 0) {
        resultsDiv.innerHTML = '<div class="text-gray-500 p-2">No customers found. You can create a new customer below.</div>';
      } else {
        resultsDiv.innerHTML = customers.map(customer => `
          <div class="border border-gray-300 rounded p-2 cursor-pointer hover:bg-blue-100 customer-result" 
               data-customer='${JSON.stringify(customer).replace(/'/g, "&#39;")}'>
            <div class="font-medium">${customer.full_name}</div>
            <div class="text-sm text-gray-600">${customer.email} • ${customer.phone}</div>
            <div class="text-xs text-gray-500">${customer.address_line1}, ${customer.city}</div>
          </div>
        `).join('');

        // Bind click events to customer results
        document.querySelectorAll('.customer-result').forEach(element => {
          element.addEventListener('click', (e) => {
            const customerData = JSON.parse(e.currentTarget.dataset.customer);
            this.selectCustomer(customerData);
          });
        });
      }

      resultsDiv.classList.remove('hidden');
    } catch (error) {
      this.showError('Error searching customers: ' + error.message);
    } finally {
      searchBtn.disabled = false;
      searchBtn.textContent = 'Search Customer';
    }
  }

  selectCustomer(customer) {
    this.selectedCustomer = customer;
    
    // Populate form fields
    document.getElementById('customer-name').value = customer.full_name || '';
    document.getElementById('customer-email').value = customer.email || '';
    document.getElementById('customer-phone').value = customer.phone || '';
    document.getElementById('customer-service-area').value = customer.service_area || '';
    document.getElementById('customer-address').value = customer.address_line1 || '';
    document.getElementById('customer-city').value = customer.city || '';
    document.getElementById('customer-province').value = customer.province || 'BC';
    document.getElementById('customer-postal-code').value = customer.postal_code || '';
    document.getElementById('customer-unit').value = customer.unit_number || '';

    // Hide search results
    document.getElementById('customer-search-results').classList.add('hidden');
    
    this.validateForm();
    this.showSuccess(`Selected existing customer: ${customer.full_name}`);
  }

  updateAddItemButton() {
    const itemSelect = document.getElementById('item-select');
    const quantityInput = document.getElementById('item-quantity');
    const addBtn = document.getElementById('add-item-btn');

    const hasItem = itemSelect.value !== '';
    const hasQuantity = parseInt(quantityInput.value) > 0;

    addBtn.disabled = !hasItem || !hasQuantity;
  }

  addItemToOrder() {
    const itemSelect = document.getElementById('item-select');
    const quantityInput = document.getElementById('item-quantity');
    
    const selectedOption = itemSelect.options[itemSelect.selectedIndex];
    if (!selectedOption || !selectedOption.value) return;

    const itemId = selectedOption.value;
    const itemName = selectedOption.dataset.name;
    const itemPrice = parseFloat(selectedOption.dataset.price);
    const quantity = parseInt(quantityInput.value);

    // Check if item already exists in order
    const existingItemIndex = this.orderItems.findIndex(item => item.itemId === itemId);
    
    if (existingItemIndex >= 0) {
      // Update quantity of existing item
      this.orderItems[existingItemIndex].quantity += quantity;
      this.orderItems[existingItemIndex].totalPrice = this.orderItems[existingItemIndex].quantity * itemPrice;
    } else {
      // Add new item to order
      this.orderItems.push({
        itemId: itemId,
        name: itemName,
        unitPrice: itemPrice,
        quantity: quantity,
        totalPrice: itemPrice * quantity
      });
    }

    // Reset form
    itemSelect.value = '';
    quantityInput.value = '1';
    this.updateAddItemButton();
    
    // Update display
    this.renderSelectedItems();
    this.calculateTotals();
    this.validateForm();
  }

  renderSelectedItems() {
    const listDiv = document.getElementById('selected-items-list');
    
    if (this.orderItems.length === 0) {
      listDiv.innerHTML = `
        <div class="text-gray-500 text-center py-4">
          No items added yet. Add items above to begin.
        </div>
      `;
      return;
    }

    listDiv.innerHTML = this.orderItems.map((item, index) => `
      <div class="flex justify-between items-center p-3 bg-white border border-gray-200 rounded-md">
        <div class="flex-1">
          <div class="font-medium text-gray-900">${item.name}</div>
          <div class="text-sm text-gray-600">
            ${item.quantity} × $${item.unitPrice.toFixed(2)} = $${item.totalPrice.toFixed(2)}
          </div>
        </div>
        <button 
          class="text-red-600 hover:text-red-800 text-sm font-medium remove-item-btn"
          data-item-index="${index}"
        >
          Remove
        </button>
      </div>
    `).join('');

    // Bind remove buttons
    document.querySelectorAll('.remove-item-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const index = parseInt(e.target.dataset.itemIndex);
        this.removeItemFromOrder(index);
      });
    });
  }

  removeItemFromOrder(index) {
    this.orderItems.splice(index, 1);
    this.renderSelectedItems();
    this.calculateTotals();
    this.validateForm();
  }

  calculateTotals() {
    const subtotal = this.orderItems.reduce((sum, item) => sum + item.totalPrice, 0);
    const isExpress = document.getElementById('is-express-service').checked;
    const deliveryFee = isExpress ? 20.00 : 15.00; // Express service costs more
   const tipAmount = parseFloat(document.getElementById('tip-amount').value) || 0;
    const discount = parseFloat(document.getElementById('manual-discount-amount').value) || 0;
   const total = subtotal + deliveryFee + tipAmount - discount;

   this.totals = { subtotal, deliveryFee, tipAmount, discount, total };

    // Update display
    document.getElementById('subtotal-display').textContent = `$${subtotal.toFixed(2)}`;
    document.getElementById('delivery-fee-display').textContent = `$${deliveryFee.toFixed(2)}`;
   document.getElementById('tip-display').textContent = `$${tipAmount.toFixed(2)}`;
    document.getElementById('discount-display').textContent = `-$${discount.toFixed(2)}`;
    document.getElementById('total-display').textContent = `$${total.toFixed(2)}`;
  }

  validateForm() {
    const requiredFields = [
      'customer-name', 'customer-email', 'customer-phone', 'customer-service-area',
      'customer-address', 'customer-city', 'pickup-date', 'pickup-time-slot',
      'delivery-date', 'delivery-time-slot'
    ];

    const allFieldsValid = requiredFields.every(fieldId => {
      const field = document.getElementById(fieldId);
      return field && field.value.trim() !== '';
    });

    const hasItems = this.orderItems.length > 0;
    const createOrderBtn = document.getElementById('create-order-btn');
    
    createOrderBtn.disabled = !allFieldsValid || !hasItems;
  }

  async createOrder() {
    if (this.isCreatingOrder) return;

    this.isCreatingOrder = true;
    this.setCreateOrderLoading(true);

    try {
      // Get form data
      const customerData = {
        full_name: document.getElementById('customer-name').value,
        email: document.getElementById('customer-email').value,
        phone: document.getElementById('customer-phone').value,
        service_area: document.getElementById('customer-service-area').value,
        address_line1: document.getElementById('customer-address').value,
        city: document.getElementById('customer-city').value,
        province: document.getElementById('customer-province').value || 'BC',
        postal_code: document.getElementById('customer-postal-code').value || '',
        unit_number: document.getElementById('customer-unit').value || null
      };

      // Create or use existing customer
      let customer = this.selectedCustomer;
      if (!customer) {
       // First check if customer already exists by email or phone
       const { data: existingCustomers, error: searchError } = await supabase
         .from('customers')
         .select('*')
         .or(`email.eq.${customerData.email},phone.eq.${customerData.phone}`);

       if (searchError) throw searchError;

       if (existingCustomers && existingCustomers.length > 0) {
         // Use existing customer
         customer = existingCustomers[0];
         this.showInfo(`Using existing customer: ${customer.full_name} (${customer.email})`);
       } else {
         // Create new customer
         const { data: newCustomer, error: customerError } = await supabase
           .from('customers')
           .insert([customerData])
           .select()
           .single();

         if (customerError) throw customerError;
         customer = newCustomer;
       }
      }

      // Get payment method
      const paymentMethod = document.querySelector('input[name="payment-method"]:checked').value;
      const paymentStatus = paymentMethod === 'manual_cash' ? 'succeeded' : 'succeeded'; // All manual orders are pre-paid

      // Create order
      const orderData = {
        customer_id: customer.id,
        status: 'pending_pickup', // Manual orders start at pending pickup
        payment_status: paymentStatus,
        subtotal: this.totals.subtotal,
        delivery_fee: this.totals.deliveryFee,
       tip_amount: this.totals.tipAmount,
        discount_amount: this.totals.discount,
        total_amount: this.totals.total,
        is_express_service: document.getElementById('is-express-service').checked,
        pickup_date: document.getElementById('pickup-date').value,
        pickup_time_slot: document.getElementById('pickup-time-slot').value,
        delivery_date: document.getElementById('delivery-date').value,
        delivery_time_slot: document.getElementById('delivery-time-slot').value,
        special_instructions: document.getElementById('special-instructions').value || null,
        payment_method: paymentMethod
      };

      const { data: newOrder, error: orderError } = await supabase
        .from('orders')
        .insert([orderData])
        .select()
        .single();

      if (orderError) throw orderError;

      // Create order items
      const orderItemsData = this.orderItems.map(item => ({
        order_id: newOrder.id,
        clothing_item_id: item.itemId,
        quantity: item.quantity,
        unit_price: item.unitPrice,
        total_price: item.totalPrice
      }));

      const { error: itemsError } = await supabase
        .from('order_items')
        .insert(orderItemsData);

      if (itemsError) throw itemsError;

      this.showSuccess(`Order ${newOrder.order_number} created successfully! Customer: ${customer.full_name}, Total: $${this.totals.total.toFixed(2)}`);
      
      // Reset form after successful creation
      setTimeout(() => {
        this.resetForm();
      }, 2000);

    } catch (error) {
      this.showError('Error creating order: ' + error.message);
    } finally {
      this.isCreatingOrder = false;
      this.setCreateOrderLoading(false);
    }
  }

  setCreateOrderLoading(loading) {
    const createBtn = document.getElementById('create-order-btn');
    const createText = document.getElementById('create-order-text');
    const createLoading = document.getElementById('create-order-loading');

    createBtn.disabled = loading;
    if (loading) {
      createText.classList.add('hidden');
      createLoading.classList.remove('hidden');
    } else {
      createText.classList.remove('hidden');
      createLoading.classList.add('hidden');
    }
  }

  resetForm() {
    // Clear customer data
    this.selectedCustomer = null;
    ['customer-search', 'customer-name', 'customer-email', 'customer-phone', 
     'customer-address', 'customer-city', 'customer-postal-code', 'customer-unit'].forEach(fieldId => {
      document.getElementById(fieldId).value = '';
    });
    
    document.getElementById('customer-service-area').value = '';
    document.getElementById('customer-province').value = 'BC';

    // Clear search results
    document.getElementById('customer-search-results').classList.add('hidden');

    // Clear order items
    this.orderItems = [];
    this.renderSelectedItems();

    // Reset form selections
    document.getElementById('item-select').value = '';
    document.getElementById('item-quantity').value = '1';
    document.getElementById('is-express-service').checked = false;
   document.getElementById('tip-amount').value = '0';
    document.getElementById('manual-discount-amount').value = '0';
    document.getElementById('special-instructions').value = '';

    // Reset payment method to cash
    document.querySelector('input[name="payment-method"][value="manual_cash"]').checked = true;

    // Reset dates to defaults
    this.setDefaultDates();

    // Recalculate totals
    this.calculateTotals();
    this.validateForm();

    this.showInfo('Form reset successfully. Ready for new order.');
  }

  showNotification(message, type = 'info') {
    const notificationDiv = document.getElementById('manual-order-notification');
    const contentDiv = document.getElementById('manual-order-notification-content');
    
    const colorClasses = {
      'info': 'bg-violet-50 text-violet-800 border border-violet-200',
      'success': 'bg-green-50 text-green-800 border border-green-200',
      'warning': 'bg-yellow-50 text-yellow-800 border border-yellow-200',
      'error': 'bg-red-50 text-red-800 border border-red-200'
    };

    notificationDiv.className = `mt-6 p-4 rounded-md ${colorClasses[type] || colorClasses.info}`;
    contentDiv.innerHTML = `
      <div class="flex items-center">
        <div class="flex-1">${message}</div>
        <button 
          onclick="document.getElementById('manual-order-notification').classList.add('hidden')" 
          class="ml-4 text-current hover:opacity-75"
        >
          ✕
        </button>
      </div>
    `;
    
    notificationDiv.classList.remove('hidden');

    // Auto-hide success and info messages after 5 seconds
    if (type === 'success' || type === 'info') {
      setTimeout(() => {
        notificationDiv.classList.add('hidden');
      }, 5000);
    }
  }

  showError(message) {
    this.showNotification(message, 'error');
  }

  showSuccess(message) {
    this.showNotification(message, 'success');
  }

  showInfo(message) {
    this.showNotification(message, 'info');
  }
}